import { addressDrawerContainerStyles } from "@dana/Overrides/Widgets/Header/AddressDrawerContainer";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";

import { css } from "styled-components";

addressDrawerContainerStyles.fulfillmentMethodGridItem = mergeToNew(
    addressDrawerContainerStyles.fulfillmentMethodGridItem,
    {
        width: 0,
    },
);

addressDrawerContainerStyles.addressesGridItemAnonymousUser = mergeToNew(
    addressDrawerContainerStyles.addressesGridItemAnonymousUser,
    {
        width: 12,
    },
);
addressDrawerContainerStyles.addressesGridItem = mergeToNew(addressDrawerContainerStyles.addressesGridItem, {
    width: 12,
});

addressDrawerContainerStyles.applyButtonGridItem = mergeToNew(addressDrawerContainerStyles.applyButtonGridItem, {
    width: 0,
});

addressDrawerContainerStyles.pickUpAddressGridItem = mergeToNew(addressDrawerContainerStyles.pickUpAddressGridItem, {
    width: 0,
});

addressDrawerContainerStyles.drawerContainer = mergeToNew(addressDrawerContainerStyles.drawerContainer, {
    css: css`
        width: 100%;
        margin: auto;
        justify-content: center;
    `,
});

addressDrawerContainerStyles.pickUpAddressGridItemAnonymousUser = mergeToNew(
    addressDrawerContainerStyles.pickUpAddressGridItemAnonymousUser,
    {
        width: 12,
    },
);
